// extracted by mini-css-extract-plugin
module.exports = {"container":"DXORnb","interaction":"_1lbneG","heading":"_1vWOHD","buttonWrapper":"_3fUNKO","register":"_1iyJtL","login":"_8Jefqi","button":"_3kk3hB"};